import(/* webpackMode: "eager" */ "/hi-ai-dev/app/global-error.tsx");
